import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControlExFactory } from '../../service/factory/form-control-ex-factory.service';
import { FormControlEx } from '../forms/form-control';
import { InputControlBase } from '../forms/input-control.base';

@Component({
    selector: 'app-ordered-item-list',
    templateUrl: 'ordered-item-list.component.html',
    styleUrls: ['ordered-item-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderedItemList extends InputControlBase implements OnInit {
  protected value: string[] = [];
  protected innerControl: FormControlEx;

  constructor(private _cf: FormControlExFactory) {
    super();
  }

  ngOnInit(): void {
    this.innerControl = this._cf.createWithOptions(this.control.caption, '', {});
    this.value.push(...this.control.value);
    this.subscription.add(
      this.control.valueChanges.subscribe({
        next: () => {
          this.value.splice(0);
          this.value.push(...this.control.value);
        },
      })
    );
  }

  public addItem(item: string, clearInput: boolean = true) {
    this.value.push(item);
    if (clearInput) {
      this.innerControl.setValue('');
    }

    this.control.setValue([...this.value]);
  }

  public deleteItem(index: number) {
    this.value.splice(index, 1);
    this.control.setValue([...this.value]);
  }

  protected dropReorder(event: CdkDragDrop<string[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      this.control.setValue([...this.value]);
    }
  }
}
